import { Router } from "@vaadin/router";

// Import Shoelace components and set base path
import "@shoelace-style/shoelace/dist/themes/light.css";
import { setBasePath } from "@shoelace-style/shoelace/dist/utilities/base-path.js";
setBasePath(
  "https://cdn.jsdelivr.net/npm/@shoelace-style/shoelace@2.14.0/cdn/",
);

// Import Bootstrap CSS
import "bootstrap/dist/css/bootstrap.min.css";

// Import our styles
import "./styles/app.css";

// Import components
import "./components/app-controller";
import "./components/app-shell";
import "./pages/login-page";
import "./pages/home-page";
import "./pages/add-entry-page";
import "./pages/history-page";
import "./pages/settings-page";
import "./pages/sample-page";
import "./pages/upload-page";
import "./pages/share-page";
import "./pages/accept-invite-page";
import "./pages/monitoring-page";
import "./pages/admin-page";
import "./pages/help-page";

// Auth state change handler for router setup
import { authService } from "./services/auth";

let routerInitialized = false;

function initializeRouter() {
  if (routerInitialized) return;

  const outlet = document.getElementById("outlet");
  if (outlet) {
    const router = new Router(outlet);
    router.setRoutes([
      { path: "/", component: "home-page" },
      { path: "/add", component: "add-entry-page" },
      { path: "/edit/:id", component: "add-entry-page" },
      { path: "/history", component: "history-page" },
      { path: "/sample", component: "sample-page" },
      { path: "/settings", component: "settings-page" },
      { path: "/upload", component: "upload-page" },
      { path: "/share", component: "share-page" },
      { path: "/invite/:code", component: "accept-invite-page" },
      { path: "/monitoring", component: "monitoring-page" },
      { path: "/admin", component: "admin-page" },
      { path: "/help", component: "help-page" },
    ]);
    routerInitialized = true;
  }
}

// Initialize router when user authenticates
authService.subscribe((state) => {
  if (state.isAuthenticated && !state.isLoading) {
    // Small delay to ensure DOM is ready
    requestAnimationFrame(() => initializeRouter());
  }
});

// Register service worker
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").catch(() => {
      // Service worker registration failed - app still works
    });
  });
}
